<template>
    <div class="m-3">
        <div class="row border-bottom ml-1 mr-1">
            <h2 class="col-6">Recently Shared Claims</h2>
            <div class="btn-toolbar ml-auto mb-1" role="toolbar">
                <div>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <label class="input-group-text" for="filterSelect" title="Filter"><i class="fas fa-filter fa-lg"></i></label>
                        </div>
                        <select class="custom-select" id="filterSelect" v-model="filter" @change="refresh()">
                            <option v-for="f in filters" :key="'recently-shared-claims-filters-' + f.id" :value="f.id">{{ f.name }}</option>
                        </select>
                    </div>
                </div>
                <div>
                    <div class="input-group ml-2">
                        <div class="input-group-prepend">
                            <label class="input-group-text" for="timeperiodSelect" title="Timeperiod"><i class="fas fa-calendar fa-lg"></i></label>
                        </div>
                        <select class="custom-select" id="timeperiodSelect" v-model="timeperiod" @change="refresh()">
                            <option v-for="t in timeperiods" :key="'recently-shared-claims-timeperiods-' + t.id" :value="t.id">{{ t.name }}</option>
                        </select>
                    </div>
                </div>
            </div>        
        </div>
        <div v-if="loading" class="pt-3">            
            <h3 class="text-muted text-center"><i class="fas fa-spinner fa-lg fa-spin align-middle"></i> Loading...</h3>
        </div>        
        <div v-else>
            <div v-if="claims.length" class="table-responsive px-2">
                <table class="table table-striped table-sm">
                    <thead>
                        <tr>
                            <th class="fit"></th>
                            <th>Claim Number</th>
                            <th>Patient</th>
                            <th>Client</th>
                            <th>Rendering Provider</th>
                            <th>Payer</th>
                            <th>Shared</th>
                            <th class="text-right"><div class="multiline-header">Estimated<br />Reimbursement</div></th>
                            <th class="text-right">Balance</th>
                            <th></th>                 
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="claim in claims" :key="'recent-claims-report-' + claim.id">
                            <td class="fit"><i v-if="claim.is_new" class="fas fa-asterisk fa-sm text-muted nudge-up" title="Unviewed"></i></td>
                            <td><a :href="'/attorney/claims/' + claim.id" v-text="claim.claim_number"></a></td>
                            <td><a :href="'/attorney/claims/' + claim.id" v-text="claim.patient_name"></a></td>
                            <td :title="claim.client_name">{{ claim.client_name | truncate(25) }}</td>
                            <td :title="claim.rendering_provider_name">{{ claim.rendering_provider_name | truncate(25) }}</td>
                            <td :title="claim.payer_name">{{ claim.payer_name | truncate(25) }}</td>
                            <td>{{ claim.shared_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                            <td class="text-right">{{ claim.estimated_reimbursement | currency }}</td>
                            <td class="text-right">{{ claim.balance | currency }}</td>
                            <td class="text-right">
                                <button v-if="!claim.is_new" class="btn btn-sm btn-link p-0" title="Revert to Unviewed" @click="setUnviewed(claim.shared_attorney_claim_id)"><i class="fas fa-undo fa-lg"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else>
                <h2 class="text-muted text-center mt-3">No recently shared claims found.</h2>
            </div>
        </div>    
    </div>    
</template>

<script>
export default {
    data() { 
        return {
            claims: [],
            filters: [],
            timeperiods: [],
            loading: true,
            timeperiod: 0,
            filter: 0
        }
    },
    methods: {
        refresh: function () {
            axios.get('/ajax/attorney/reports/shared-claims', { 
                params: { 
                    filter: this.filter,
                    timeperiod: this.timeperiod
                }
            })
            .then(response => {
                this.filters = response.data.filters;
                this.timeperiods = response.data.timeperiods;
                this.claims = response.data.claims;
                this.loading = false;
            })
            .catch(error => {
                this.loading = false;
            });
        },
        setUnviewed: function (id) {
            axios.patch('/ajax/attorney/reports/shared-claims/' + id)
                .then(response => {
                    this.refresh();
                })                
        }
    },
    created() {
        this.refresh();
    }    
}
</script>

<style scoped>
    .multiline-header {
        display: inline-block;
        text-align: left;
    }

    .nudge-up {
        position: relative;
        top: -4px;
    }
</style>